/**
 * KAN-856: Telegram клиента в шапке карточки приложения рядом с "Позвонить":
 * кнопка "Написать в Telegram" (ссылка по clientTelegramLink: username, иначе
 * номер, иначе telegram_id), подпись аккаунта и строка "Пишет наш аккаунт",
 * если аккаунт переписки известен. Нечего показать: ничего.
 */
import { Send } from 'lucide-react';
import { clientTelegramLink, senderAccountText } from '@/lib/mobileClient';
import type { Client } from '@/types/client';

type TelegramClient = Pick<Client, 'telegram_username' | 'phone' | 'telegram_id' | 'sender_account'>;

export function MobileClientTelegram({ client }: { client: TelegramClient }): JSX.Element | null {
  const telegram = clientTelegramLink(client);
  const account = senderAccountText(client.sender_account);
  if (!telegram && !account) return null;
  // tg:// открывает приложение Telegram, новая вкладка ему не нужна.
  const external = telegram?.href.startsWith('https://') ?? false;

  return (
    <div className="space-y-1" data-testid="mobile-client-telegram-block">
      {telegram && (
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <a
            href={telegram.href}
            {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            className="inline-flex min-h-[44px] items-center gap-2 rounded-lg border border-sky-300 bg-white px-4 py-2 text-base font-medium text-sky-700 active:bg-sky-50"
            data-testid="mobile-client-telegram"
          >
            <Send className="h-5 w-5" aria-hidden="true" />
            Написать в Telegram
          </a>
          <span className="break-all text-gray-700" data-testid="mobile-client-telegram-text">
            {telegram.text}
          </span>
        </div>
      )}
      {account && (
        <p className="text-sm text-gray-600">
          Пишет наш аккаунт: <span className="text-gray-900" data-testid="mobile-client-sender">{account}</span>
        </p>
      )}
    </div>
  );
}
